import React from "react";

import { IconProps } from "../../types/common";

const ReturnIcon = ({
  width = "24",
  height = "24",
  style,
  className,
  fillClassName,
  fillColor = "#63696F",
}: IconProps) => (
  <svg
    style={style}
    width={width}
    height={height}
    aria-hidden="true"
    viewBox="0 0 24 24"
    className={className}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      fill={fillColor!}
      className={fillClassName}
      d="M18.8 11H7.61l4.88-4.88a1 1 0 000-1.42 1 1 0 00-1.4 0l-6.6 6.6a1 1 0 000 1.4l6.6 6.6a1 1 0 101.4-1.41L7.62 13H18.8a1 1 0 001-1 1 1 0 00-1-1z"
    />
  </svg>
);

export default ReturnIcon;
